// import * as types from "../actions/membershipApplicationActionTypes";

// const initialState = {
//   contactInfo: { data: null, loading: false, saving:false, error: null },
//   businessInfo: { data: null, loading: false, saving:false, error: null },
//   officers: { data: null, loading: false, saving:false, error: null },
//   expectations: { data: null, loading: false, saving:false, error: null },
//   references: { data: null, loading: false, saving:false, error: null },
//   legalForm: { data: null, loading: false, saving:false, error: null },
//   declaration: { data: null, loading: false, saving:false, error: null },
//   membershipTiers: { data: [], loading: false, error: null },
//   relationships: { data: [], loading: false, saving:false, error: null },
//   documents: { data: [], loading: false, error: null },
//   membershipRequests: { data: [], loading: false, error: null },
//   submitStatus: { loading: false, error: null, success: false },
//   membership: { data: null, loading: false, error: null },
//   membershipRequestDetails: { data: null, loading: false, error: null },
//   membershipConfirmationDetails: { data: null, loading: false, error: null },
// };

// export default function membershipApplicationReducer(state = initialState, action) {
//   switch (action.type) {


//     // ---------------- Contact Info ----------------
//     case types.FETCH_CONTACT_INFO_REQUEST:
//     case types.CREATE_CONTACT_INFO_REQUEST:
//     case types.UPDATE_CONTACT_INFO_REQUEST:
//       return {
//         ...state,
//         contactInfo: { ...state.contactInfo, loading: true, error: null },
//       };

//     case types.FETCH_CONTACT_INFO_SUCCESS:
//     case types.CREATE_CONTACT_INFO_SUCCESS:
//     case types.UPDATE_CONTACT_INFO_SUCCESS:
//       return {
//         ...state,
//         contactInfo: { ...state.contactInfo, loading: false, data: action.payload },
//       };

//     case types.FETCH_CONTACT_INFO_FAILURE:
//     case types.CREATE_CONTACT_INFO_FAILURE:
//     case types.UPDATE_CONTACT_INFO_FAILURE:
//       return {
//         ...state,
//         contactInfo: { ...state.contactInfo, loading: false, error: action.payload },
//       };





//     // ---------------- Business Info ----------------
//     case types.FETCH_BUSINESS_INFO_REQUEST:
//     case types.CREATE_BUSINESS_INFO_REQUEST:
//     case types.UPDATE_BUSINESS_INFO_REQUEST:
//       return {
//         ...state,
//         businessInfo: { ...state.businessInfo, loading: true, error: null },
//       };

//     case types.FETCH_BUSINESS_INFO_SUCCESS:
//     case types.CREATE_BUSINESS_INFO_SUCCESS:
//     case types.UPDATE_BUSINESS_INFO_SUCCESS:
//       return {
//         ...state,
//         businessInfo: { ...state.businessInfo, loading: false, data: action.payload },
//       };

//     case types.FETCH_BUSINESS_INFO_FAILURE:
//     case types.CREATE_BUSINESS_INFO_FAILURE:
//     case types.UPDATE_BUSINESS_INFO_FAILURE:
//       return {
//         ...state,
//         businessInfo: { ...state.businessInfo, loading: false, error: action.payload },
//       };





//     // ---------------- Officers ----------------
//     case types.FETCH_OFFICERS_REQUEST:
//     case types.CREATE_OFFICERS_REQUEST:
//       return {
//         ...state,
//         officers: { ...state.officers, loading: true, error: null },
//       };

//     case types.FETCH_OFFICERS_SUCCESS:
//       return {
//         ...state,
//         officers: { loading: false, error: null, data: action.payload }, // replace list
//       };

//     case types.CREATE_OFFICERS_SUCCESS:
//       return {
//         ...state,
//         officers: { loading: false, error: null, data: action.payload }, // overwrite with full list
//       };

//     case types.FETCH_OFFICERS_FAILURE:
//     case types.CREATE_OFFICERS_FAILURE:
//       return {
//         ...state,
//         officers: { ...state.officers, loading: false, error: action.payload },
//       };




//     // ---------------- Overseas Relationships -----------------------
//     case types.FETCH_OVERSEAS_RELATIONSHIPS_REQUEST:
//     case types.CREATE_OVERSEAS_RELATIONSHIPS_REQUEST:
//       return {
//         ...state,
//         relationships: { ...state.relationships, loading: true, error: null },
//       };

//     case types.FETCH_OVERSEAS_RELATIONSHIPS_SUCCESS:
//       return {
//         ...state,
//         relationships: { loading: false, error: null, data: action.payload },
//       };

//     case types.CREATE_OVERSEAS_RELATIONSHIPS_SUCCESS:
//       return {
//         ...state,
//         relationships: { loading: false, error: null, data: action.payload },
//       };

//     case types.FETCH_OVERSEAS_RELATIONSHIPS_FAILURE:
//     case types.CREATE_OVERSEAS_RELATIONSHIPS_FAILURE:
//       return {
//         ...state,
//         relationships: { ...state.relationships, loading: false, error: action.payload },
//       };




//     // ---------------- Expectations ----------------
//     case types.FETCH_EXPECTATIONS_REQUEST:
//     case types.UPDATE_EXPECTATIONS_REQUEST:
//       return {
//         ...state,
//         expectations: { ...state.expectations, loading: true, error: null },
//       };

//     case types.FETCH_EXPECTATIONS_SUCCESS:
//     case types.UPDATE_EXPECTATIONS_SUCCESS:
//       return {
//         ...state,
//         expectations: { ...state.expectations, loading: false, data: action.payload },
//       };

//     case types.FETCH_EXPECTATIONS_FAILURE:
//     case types.UPDATE_EXPECTATIONS_FAILURE:
//       return {
//         ...state,
//         expectations: { ...state.expectations, loading: false, error: action.payload },
//       };




//     // ---------------- References ----------------
//     case types.FETCH_REFERENCES_REQUEST:
//     case types.UPDATE_REFERENCES_REQUEST:
//       return {
//         ...state,
//         references: { ...state.references, loading: true, error: null },
//       };

//     case types.FETCH_REFERENCES_SUCCESS:
//     case types.UPDATE_REFERENCES_SUCCESS:
//       return {
//         ...state,
//         references: { ...state.references, loading: false, data: action.payload },
//       };

//     case types.FETCH_REFERENCES_FAILURE:
//     case types.UPDATE_REFERENCES_FAILURE:
//       return {
//         ...state,
//         references: { ...state.references, loading: false, error: action.payload },
//       };





//     // ---------------- Legal Form ----------------
//     case types.FETCH_LEGAL_FORM_REQUEST:
//     case types.UPDATE_LEGAL_FORM_REQUEST:
//       return {
//         ...state,
//         legalForm: { ...state.legalForm, loading: true, error: null },
//       };

//     case types.FETCH_LEGAL_FORM_SUCCESS:
//     case types.UPDATE_LEGAL_FORM_SUCCESS:
//       return {
//         ...state,
//         legalForm: { ...state.legalForm, loading: false, data: action.payload },
//       };

//     case types.FETCH_LEGAL_FORM_FAILURE:
//     case types.UPDATE_LEGAL_FORM_FAILURE:
//       return {
//         ...state,
//         legalForm: { ...state.legalForm, loading: false, error: action.payload },
//       };





//     // ---------------- Declaration ----------------
//     case types.FETCH_DECLARATION_REQUEST:
//     case types.UPDATE_DECLARATION_REQUEST:
//       return {
//         ...state,
//         declaration: { ...state.declaration, loading: true, error: null },
//       };
//     case types.FETCH_DECLARATION_SUCCESS:
//     case types.UPDATE_DECLARATION_SUCCESS:
//       return {
//         ...state,
//         declaration: { ...state.declaration, loading: false, data: action.payload },
//       };
//     case types.FETCH_DECLARATION_FAILURE:
//     case types.UPDATE_DECLARATION_FAILURE:
//       return {
//         ...state,
//         declaration: { ...state.declaration, loading: false, error: action.payload },
//       };





//     // ---------------- Documents ----------------
//     case types.FETCH_DOCUMENTS_REQUEST:
//     case types.UPLOAD_DOCUMENTS_REQUEST:
//       return {
//         ...state,
//         documents: { ...state.documents, loading: true, error: null },
//       };
      


//     case types.FETCH_DOCUMENTS_SUCCESS:
//     case types.UPLOAD_DOCUMENTS_SUCCESS:
//       const documentsByType = {};
//       (action.payload || []).forEach(doc => {
//         documentsByType[doc.documentType] = doc;
//       });
//       return {
//         ...state,
//         documents: { loading: false, error: null, data: documentsByType },
//       };


//     case types.FETCH_DOCUMENTS_FAILURE:
//     case types.UPLOAD_DOCUMENTS_FAILURE:
//       return {
//         ...state,
//         documents: { ...state.documents, loading: false, error: action.payload },
//       };







//     // ---------------- Membership Tiers ----------------
//     case types.FETCH_MEMBERSHIP_TIERS_REQUEST:
//       return { 
//         ...state, 
//         membershipTiers: { ...state.membershipTiers, loading: true, error: null } 
//       };

//     case types.FETCH_MEMBERSHIP_TIERS_SUCCESS:
//       return { 
//         ...state, 
//         membershipTiers: { data: action.payload, loading: false, error: null } 
//       };

//     case types.FETCH_MEMBERSHIP_TIERS_FAILURE:
//       return { 
//         ...state, 
//         membershipTiers: { ...state.membershipTiers, loading: false, error: action.payload } 
//       };




//     // ---------------- Submit ----------------
//     case types.SUBMIT_MEMBERSHIP_REQUEST:
//       return {
//         ...state,
//         submitStatus: { loading: true, error: null, success: false },
//       };
//     case types.SUBMIT_MEMBERSHIP_SUCCESS:
//       return {
//         ...state,
//         submitStatus: { loading: false, error: null, success: true, data: action.payload },
//       };
//     case types.SUBMIT_MEMBERSHIP_FAILURE:
//       return {
//         ...state,
//         submitStatus: { loading: false, error: action.payload, success: false },
//       };





//     // Review end 
// // in membershipApplicationReducer
// case types.FETCH_MEMBERSHIP_DETAILS_REQUEST:
//   return {
//     ...state,
//     membershipRequestDetails: { ...state.membershipRequestDetails, loading: true, error: null },
//   };

// case types.FETCH_MEMBERSHIP_DETAILS_SUCCESS:
//   return {
//     ...state,
//     membershipRequestDetails: { data: action.payload, loading: false, error: null },
//   };

// case types.FETCH_MEMBERSHIP_DETAILS_FAILURE:
//   return {
//     ...state,
//     membershipRequestDetails: { ...state.membershipRequestDetails, loading: false, error: action.payload },
//   };




//     // Membership from admin end
//         // ---------------- Membership Requests ----------------
//     case types.FETCH_MEMBERSHIP_REQUESTS_REQUEST:
//       return {
//         ...state,
//         membershipRequests: { ...state.membershipRequests, loading: true, error: null },
//       };

//     case types.FETCH_MEMBERSHIP_REQUESTS_SUCCESS:
//       return {
//         ...state,
//         membershipRequests: { data: action.payload, loading: false, error: null },
//       };

//     case types.FETCH_MEMBERSHIP_REQUESTS_FAILURE:
//       return {
//         ...state,
//         membershipRequests: { ...state.membershipRequests, loading: false, error: action.payload },
//       };



//       // ---------------- Membership by ID ----------------
//       case types.FETCH_USER_MEMBERSHIP_REQUEST_REQUEST:
//         return {
//           ...state,
//           membership: { ...state.membership, loading: true, error: null },
//         };

//       case types.FETCH_USER_MEMBERSHIP_REQUEST_SUCCESS:
//         return {
//           ...state,
//           membership: { data: action.payload, loading: false, error: null },
//         };

//       case types.FETCH_USER_MEMBERSHIP_REQUEST_FAILURE:
//         return {
//           ...state,
//           membership: { ...state.membership, loading: false, error: action.payload },
//         };


//       // ---------------- Membership Confirmation Details ----------------
//       case types.FETCH_MEMBERSHIP_CONFIRMATION_DETAILS_REQUEST:
//         return {
//           ...state,
//           membershipConfirmationDetails: {
//             ...state.membershipConfirmationDetails,
//             loading: true,
//             error: null,
//           },
//         };

//       case types.FETCH_MEMBERSHIP_CONFIRMATION_DETAILS_SUCCESS:
//         return {
//           ...state,
//           membershipConfirmationDetails: {
//             data: action.payload,
//             loading: false,
//             error: null,
//           },
//         };

//       case types.FETCH_MEMBERSHIP_CONFIRMATION_DETAILS_FAILURE:
//         return {
//           ...state,
//           membershipConfirmationDetails: {
//             ...state.membershipConfirmationDetails,
//             loading: false,
//             error: action.payload,
//           },
//         };




//     default:
//       return state;
//   }
// }







































import * as types from "../actions/membershipApplicationActionTypes";

const initialState = {
  contactInfo: { data: null, loading: false, saving: false, error: null },
  businessInfo: { data: null, loading: false, saving: false, error: null },
  officers: { data: null, loading: false, saving: false, error: null },
  expectations: { data: null, loading: false, saving: false, error: null },
  references: { data: null, loading: false, saving: false, error: null },
  legalForm: { data: null, loading: false, saving: false, error: null },
  declaration: { data: null, loading: false, saving: false, error: null },
  membershipTiers: { data: [], loading: false, error: null },
  relationships: { data: [], loading: false, saving: false, error: null },
  documents: { data: [], loading: false, saving: false, error: null },
  membershipRequests: { data: [], loading: false, error: null },
  submitStatus: { loading: false, error: null, success: false },
  membership: { data: null, loading: false, error: null },
  membershipRequestDetails: { data: null, loading: false, error: null },
  membershipConfirmationDetails: { data: null, loading: false, error: null },
};

export default function membershipApplicationReducer(state = initialState, action) {
  switch (action.type) {
    // ---------------- Contact Info ----------------
    case types.FETCH_CONTACT_INFO_REQUEST:
      return {
        ...state,
        contactInfo: { ...state.contactInfo, loading: true, error: null },
      };
    case types.FETCH_CONTACT_INFO_SUCCESS:
      return {
        ...state,
        contactInfo: { ...state.contactInfo, loading: false, data: action.payload },
      };
    case types.FETCH_CONTACT_INFO_FAILURE:
      return {
        ...state,
        contactInfo: { ...state.contactInfo, loading: false, error: action.payload },
      };

    case types.CREATE_CONTACT_INFO_REQUEST:
    case types.UPDATE_CONTACT_INFO_REQUEST:
      return {
        ...state,
        contactInfo: { ...state.contactInfo, saving: true, error: null },
      };
    case types.CREATE_CONTACT_INFO_SUCCESS:
    case types.UPDATE_CONTACT_INFO_SUCCESS:
      return {
        ...state,
        contactInfo: { ...state.contactInfo, saving: false, data: action.payload },
      };
    case types.CREATE_CONTACT_INFO_FAILURE:
    case types.UPDATE_CONTACT_INFO_FAILURE:
      return {
        ...state,
        contactInfo: { ...state.contactInfo, saving: false, error: action.payload },
      };

    // ---------------- Business Info ----------------
    case types.FETCH_BUSINESS_INFO_REQUEST:
      return {
        ...state,
        businessInfo: { ...state.businessInfo, loading: true, error: null },
      };
    case types.FETCH_BUSINESS_INFO_SUCCESS:
      return {
        ...state,
        businessInfo: { ...state.businessInfo, loading: false, data: action.payload },
      };
    case types.FETCH_BUSINESS_INFO_FAILURE:
      return {
        ...state,
        businessInfo: { ...state.businessInfo, loading: false, error: action.payload },
      };

    case types.CREATE_BUSINESS_INFO_REQUEST:
    case types.UPDATE_BUSINESS_INFO_REQUEST:
      return {
        ...state,
        businessInfo: { ...state.businessInfo, saving: true, error: null },
      };
    case types.CREATE_BUSINESS_INFO_SUCCESS:
    case types.UPDATE_BUSINESS_INFO_SUCCESS:
      return {
        ...state,
        businessInfo: { ...state.businessInfo, saving: false, data: action.payload },
      };
    case types.CREATE_BUSINESS_INFO_FAILURE:
    case types.UPDATE_BUSINESS_INFO_FAILURE:
      return {
        ...state,
        businessInfo: { ...state.businessInfo, saving: false, error: action.payload },
      };

    // ---------------- Officers ----------------
    case types.FETCH_OFFICERS_REQUEST:
      return {
        ...state,
        officers: { ...state.officers, loading: true, error: null },
      };
    case types.FETCH_OFFICERS_SUCCESS:
      return {
        ...state,
        officers: { ...state.officers, loading: false, data: action.payload },
      };
    case types.FETCH_OFFICERS_FAILURE:
      return {
        ...state,
        officers: { ...state.officers, loading: false, error: action.payload },
      };

    case types.CREATE_OFFICERS_REQUEST:
      return {
        ...state,
        officers: { ...state.officers, saving: true, error: null },
      };
    case types.CREATE_OFFICERS_SUCCESS:
      return {
        ...state,
        officers: { ...state.officers, saving: false, data: action.payload },
      };
    case types.CREATE_OFFICERS_FAILURE:
      return {
        ...state,
        officers: { ...state.officers, saving: false, error: action.payload },
      };

    // ---------------- Overseas Relationships ----------------
    case types.FETCH_OVERSEAS_RELATIONSHIPS_REQUEST:
      return {
        ...state,
        relationships: { ...state.relationships, loading: true, error: null },
      };
    case types.FETCH_OVERSEAS_RELATIONSHIPS_SUCCESS:
      return {
        ...state,
        relationships: { ...state.relationships, loading: false, data: action.payload },
      };
    case types.FETCH_OVERSEAS_RELATIONSHIPS_FAILURE:
      return {
        ...state,
        relationships: { ...state.relationships, loading: false, error: action.payload },
      };

    case types.CREATE_OVERSEAS_RELATIONSHIPS_REQUEST:
      return {
        ...state,
        relationships: { ...state.relationships, saving: true, error: null },
      };
    case types.CREATE_OVERSEAS_RELATIONSHIPS_SUCCESS:
      return {
        ...state,
        relationships: { ...state.relationships, saving: false, data: action.payload },
      };
    case types.CREATE_OVERSEAS_RELATIONSHIPS_FAILURE:
      return {
        ...state,
        relationships: { ...state.relationships, saving: false, error: action.payload },
      };

    // ---------------- Expectations ----------------
    case types.FETCH_EXPECTATIONS_REQUEST:
      return {
        ...state,
        expectations: { ...state.expectations, loading: true, error: null },
      };
    case types.FETCH_EXPECTATIONS_SUCCESS:
      return {
        ...state,
        expectations: { ...state.expectations, loading: false, data: action.payload },
      };
    case types.FETCH_EXPECTATIONS_FAILURE:
      return {
        ...state,
        expectations: { ...state.expectations, loading: false, error: action.payload },
      };

    case types.UPDATE_EXPECTATIONS_REQUEST:
      return {
        ...state,
        expectations: { ...state.expectations, saving: true, error: null },
      };
    case types.UPDATE_EXPECTATIONS_SUCCESS:
      return {
        ...state,
        expectations: { ...state.expectations, saving: false, data: action.payload },
      };
    case types.UPDATE_EXPECTATIONS_FAILURE:
      return {
        ...state,
        expectations: { ...state.expectations, saving: false, error: action.payload },
      };

    // ---------------- References ----------------
    case types.FETCH_REFERENCES_REQUEST:
      return {
        ...state,
        references: { ...state.references, loading: true, error: null },
      };
    case types.FETCH_REFERENCES_SUCCESS:
      return {
        ...state,
        references: { ...state.references, loading: false, data: action.payload },
      };
    case types.FETCH_REFERENCES_FAILURE:
      return {
        ...state,
        references: { ...state.references, loading: false, error: action.payload },
      };

    case types.UPDATE_REFERENCES_REQUEST:
      return {
        ...state,
        references: { ...state.references, saving: true, error: null },
      };
    case types.UPDATE_REFERENCES_SUCCESS:
      return {
        ...state,
        references: { ...state.references, saving: false, data: action.payload },
      };
    case types.UPDATE_REFERENCES_FAILURE:
      return {
        ...state,
        references: { ...state.references, saving: false, error: action.payload },
      };

    // ---------------- Legal Form ----------------
    case types.FETCH_LEGAL_FORM_REQUEST:
      return {
        ...state,
        legalForm: { ...state.legalForm, loading: true, error: null },
      };
    case types.FETCH_LEGAL_FORM_SUCCESS:
      return {
        ...state,
        legalForm: { ...state.legalForm, loading: false, data: action.payload },
      };
    case types.FETCH_LEGAL_FORM_FAILURE:
      return {
        ...state,
        legalForm: { ...state.legalForm, loading: false, error: action.payload },
      };

    case types.UPDATE_LEGAL_FORM_REQUEST:
      return {
        ...state,
        legalForm: { ...state.legalForm, saving: true, error: null },
      };
    case types.UPDATE_LEGAL_FORM_SUCCESS:
      return {
        ...state,
        legalForm: { ...state.legalForm, saving: false, data: action.payload },
      };
    case types.UPDATE_LEGAL_FORM_FAILURE:
      return {
        ...state,
        legalForm: { ...state.legalForm, saving: false, error: action.payload },
      };

    // ---------------- Declaration ----------------
    case types.FETCH_DECLARATION_REQUEST:
      return {
        ...state,
        declaration: { ...state.declaration, loading: true, error: null },
      };
    case types.FETCH_DECLARATION_SUCCESS:
      return {
        ...state,
        declaration: { ...state.declaration, loading: false, data: action.payload },
      };
    case types.FETCH_DECLARATION_FAILURE:
      return {
        ...state,
        declaration: { ...state.declaration, loading: false, error: action.payload },
      };

    case types.UPDATE_DECLARATION_REQUEST:
      return {
        ...state,
        declaration: { ...state.declaration, saving: true, error: null },
      };
    case types.UPDATE_DECLARATION_SUCCESS:
      return {
        ...state,
        declaration: { ...state.declaration, saving: false, data: action.payload },
      };
    case types.UPDATE_DECLARATION_FAILURE:
      return {
        ...state,
        declaration: { ...state.declaration, saving: false, error: action.payload },
      };

    // ---------------- Documents ----------------
    case types.FETCH_DOCUMENTS_REQUEST:
      return {
        ...state,
        documents: { ...state.documents, loading: true, error: null },
      };
    case types.FETCH_DOCUMENTS_SUCCESS:
      const documentsByType = {};
      (action.payload || []).forEach((doc) => {
        documentsByType[doc.documentType] = doc;
      });
      return {
        ...state,
        documents: { ...state.documents, loading: false, data: documentsByType },
      };
    case types.FETCH_DOCUMENTS_FAILURE:
      return {
        ...state,
        documents: { ...state.documents, loading: false, error: action.payload },
      };

    case types.UPLOAD_DOCUMENTS_REQUEST:
      return {
        ...state,
        documents: { ...state.documents, saving: true, error: null },
      };
    case types.UPLOAD_DOCUMENTS_SUCCESS:
      const uploadedDocsByType = {};
      (action.payload || []).forEach((doc) => {
        uploadedDocsByType[doc.documentType] = doc;
      });
      return {
        ...state,
        documents: { ...state.documents, saving: false, data: uploadedDocsByType },
      };
    case types.UPLOAD_DOCUMENTS_FAILURE:
      return {
        ...state,
        documents: { ...state.documents, saving: false, error: action.payload },
      };

    // ---------------- Membership Tiers ----------------
    case types.FETCH_MEMBERSHIP_TIERS_REQUEST:
      return {
        ...state,
        membershipTiers: { ...state.membershipTiers, loading: true, error: null },
      };
    case types.FETCH_MEMBERSHIP_TIERS_SUCCESS:
      return {
        ...state,
        membershipTiers: { data: action.payload, loading: false, error: null },
      };
    case types.FETCH_MEMBERSHIP_TIERS_FAILURE:
      return {
        ...state,
        membershipTiers: { ...state.membershipTiers, loading: false, error: action.payload },
      };

    // ---------------- Submit ----------------
    case types.SUBMIT_MEMBERSHIP_REQUEST:
      return {
        ...state,
        submitStatus: { loading: true, error: null, success: false },
      };
    case types.SUBMIT_MEMBERSHIP_SUCCESS:
      return {
        ...state,
        submitStatus: { loading: false, error: null, success: true, data: action.payload },
      };
    case types.SUBMIT_MEMBERSHIP_FAILURE:
      return {
        ...state,
        submitStatus: { loading: false, error: action.payload, success: false },
      };

    // ---------------- Membership Details ----------------
    case types.FETCH_MEMBERSHIP_DETAILS_REQUEST:
      return {
        ...state,
        membershipRequestDetails: { ...state.membershipRequestDetails, loading: true, error: null },
      };
    case types.FETCH_MEMBERSHIP_DETAILS_SUCCESS:
      return {
        ...state,
        membershipRequestDetails: { data: action.payload, loading: false, error: null },
      };
    case types.FETCH_MEMBERSHIP_DETAILS_FAILURE:
      return {
        ...state,
        membershipRequestDetails: { ...state.membershipRequestDetails, loading: false, error: action.payload },
      };

    // ---------------- Membership Requests ----------------
    case types.FETCH_MEMBERSHIP_REQUESTS_REQUEST:
      return {
        ...state,
        membershipRequests: { ...state.membershipRequests, loading: true, error: null },
      };
    case types.FETCH_MEMBERSHIP_REQUESTS_SUCCESS:
      return {
        ...state,
        membershipRequests: { data: action.payload, loading: false, error: null },
      };
    case types.FETCH_MEMBERSHIP_REQUESTS_FAILURE:
      return {
        ...state,
        membershipRequests: { ...state.membershipRequests, loading: false, error: action.payload },
      };

    // ---------------- Membership by ID ----------------
    case types.FETCH_USER_MEMBERSHIP_REQUEST_REQUEST:
      return {
        ...state,
        membership: { ...state.membership, loading: true, error: null },
      };
    case types.FETCH_USER_MEMBERSHIP_REQUEST_SUCCESS:
      return {
        ...state,
        membership: { data: action.payload, loading: false, error: null },
      };
    case types.FETCH_USER_MEMBERSHIP_REQUEST_FAILURE:
      return {
        ...state,
        membership: { ...state.membership, loading: false, error: action.payload },
      };

    // ---------------- Membership Confirmation Details ----------------
    case types.FETCH_MEMBERSHIP_CONFIRMATION_DETAILS_REQUEST:
      return {
        ...state,
        membershipConfirmationDetails: {
          ...state.membershipConfirmationDetails,
          loading: true,
          error: null,
        },
      };
    case types.FETCH_MEMBERSHIP_CONFIRMATION_DETAILS_SUCCESS:
      return {
        ...state,
        membershipConfirmationDetails: {
          data: action.payload,
          loading: false,
          error: null,
        },
      };
    case types.FETCH_MEMBERSHIP_CONFIRMATION_DETAILS_FAILURE:
      return {
        ...state,
        membershipConfirmationDetails: {
          ...state.membershipConfirmationDetails,
          loading: false,
          error: action.payload,
        },
      };

    default:
      return state;
  }
}

